module.exports = __webpack_public_path__ + "static/img/f67d83fa274b9d0b392a3ca3f8a4ab9e.267a822.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f67d83fa274b9d0b392a3ca3f8a4ab9e.jpg
// module id = YOoa
// module chunks = 1